import _ from 'lodash'
import { SET_ANSWERS_FEEDBACK_PAGE } from 'actions'

const initialState = {
  selectedCustomer: null,
  numberOfFeedback: 0,
  allAnswersId: [],
}

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ANSWERS_FEEDBACK_PAGE: {
      const ids = action.answers.map((answer) => answer.id)
      return _.merge({}, state, {
        numberOfFeedback: action.numberOfAnswers,
        allAnswersId: ids,
      })
    }
    default:
      return state
  }
}

export default feedbackReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/feedback/index.js